/**
 * Boss warning overlay — shows a dramatic warning before boss fight starts
 * Also includes first-time boss tutorial popup
 */

import { t } from '../i18n/index.js';
import { playSfx } from '../sound.js';

/** Full-screen flashing warning before boss appears */
export function showBossWarning(onComplete: () => void): void {
  const overlay = document.createElement('div');
  overlay.className = 'boss-warning-overlay';
  overlay.innerHTML = `
    <div class="boss-warning-content">
      <div class="boss-warning-icon">\u{26A0}</div>
      <div class="boss-warning-text">${t('boss_warning')}</div>
      <div class="boss-warning-sub">${t('boss_warning_sub')}</div>
    </div>
  `;
  document.body.appendChild(overlay);
  playSfx('goldenEvent');

  // Warning lasts 2 seconds, then transition to boss
  setTimeout(() => {
    overlay.classList.add('fade-out');
    setTimeout(() => {
      overlay.remove();
      onComplete();
    }, 300);
  }, 2000);
}

/** First-time boss tutorial popup */
export function showBossTutorial(onComplete: () => void): void {
  const overlay = document.createElement('div');
  overlay.className = 'modal-overlay';
  overlay.innerHTML = `
    <div class="modal boss-tutorial-popup">
      <div class="boss-tutorial-icon">\u{1F47E}</div>
      <div class="modal-title">${t('boss_tutorial_title')}</div>
      <div class="modal-body">${t('boss_tutorial_text')}</div>
      <div class="modal-btns">
        <button class="modal-btn primary" id="boss-tutorial-ok">${t('confirm')}</button>
      </div>
    </div>
  `;
  document.body.appendChild(overlay);

  document.getElementById('boss-tutorial-ok')?.addEventListener('click', () => {
    overlay.remove();
    onComplete();
  });
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) {
      overlay.remove();
      onComplete();
    }
  });
}
